import { NoteField, type NoteFieldProps } from '@shared/components/forms/fields/NoteField'

export type OperationCommentsFieldProps = NoteFieldProps

// Payment-operations default: "Comments (optional)" label keeps backwards compat with existing dialogs
export function OperationCommentsField({
  label = 'Comments (optional)',
  placeholder = 'Add any additional details or context...',
  ...rest
}: OperationCommentsFieldProps) {
  return <NoteField label={label} placeholder={placeholder} {...rest} />
}
